import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import "regenerator-runtime/runtime";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(settingsOnEnterSaga),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(updateOnEnterSaga),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(plansOnEnterSaga),
    _marked4 =
/*#__PURE__*/
regeneratorRuntime.mark(addOnsOnEnterSaga);

import { fetchEntityIfNeeded } from '@classpass/saga-tools';
import { all, call, select } from 'redux-saga/effects';
import { userPermissions, userProfile, userSubscription } from 'redux/saga/entities/bound';
import { isLoggedIn } from 'redux/saga/selectors';
import { gtmSafeRedirect } from 'redux/saga/helpers';
import { deepExtract } from 'helpers/deep';
import PlanDeriver from 'derivers/Plan';
import loginRedirectUrl from 'helpers/loginRedirectUrl';
import { memberStatus } from 'enums/memberStatus';
import { SCREEN_TYPES } from 'constants/media-queries';
import { HOW_TO_CANCEL } from 'constants/helpdeskLinks';
import { selectDeviceType, selectQuery } from 'redux/modules/request';
import queryString from 'query-string';
export function settingsOnEnterSaga(client, nextState, replaceState) {
  return regeneratorRuntime.wrap(function settingsOnEnterSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return select(isLoggedIn);

        case 2:
          if (_context.sent) {
            _context.next = 5;
            break;
          }

          _context.next = 5;
          return call(replaceState, loginRedirectUrl(nextState.location));

        case 5:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
export function updateOnEnterSaga(client, replaceState) {
  var profile, subscription, plan, _ref, _ref2, deviceType, queryVars, isMobile, isWebview, qs;

  return regeneratorRuntime.wrap(function updateOnEnterSaga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return call(fetchEntityIfNeeded, userProfile, [client]);

        case 2:
          profile = _context2.sent;
          _context2.next = 5;
          return call(fetchEntityIfNeeded, userSubscription, [client, profile.id]);

        case 5:
          subscription = _context2.sent;
          plan = deepExtract('current_subscription.plan', subscription);

          if (!PlanDeriver.isCostcoPlan(plan)) {
            _context2.next = 24;
            break;
          }

          _context2.next = 10;
          return all([select(selectDeviceType), select(selectQuery)]);

        case 10:
          _ref = _context2.sent;
          _ref2 = _slicedToArray(_ref, 2);
          deviceType = _ref2[0];
          queryVars = _ref2[1];
          isMobile = [SCREEN_TYPES.phone, SCREEN_TYPES.tablet].includes(deviceType);
          isWebview = !!queryVars.webview;

          if (!(isMobile && !isWebview)) {
            _context2.next = 20;
            break;
          }

          _context2.next = 19;
          return call(gtmSafeRedirect, HOW_TO_CANCEL);

        case 19:
          return _context2.abrupt("return", _context2.sent);

        case 20:
          qs = queryString.stringify(queryVars);
          _context2.next = 23;
          return call(replaceState, "/settings/membership/update/cancel".concat(qs ? "?".concat(qs) : ''));

        case 23:
          return _context2.abrupt("return", _context2.sent);

        case 24:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}
export function plansOnEnterSaga(client, replaceState, nextState) {
  var profile, subscription, plan, searchString;
  return regeneratorRuntime.wrap(function plansOnEnterSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return call(fetchEntityIfNeeded, userProfile, [client]);

        case 2:
          profile = _context3.sent;

          if (memberStatus('ACTIVE', profile && profile.membership && profile.membership.status)) {
            _context3.next = 7;
            break;
          }

          _context3.next = 6;
          return call(replaceState, '/settings');

        case 6:
          return _context3.abrupt("return", _context3.sent);

        case 7:
          _context3.next = 9;
          return call(fetchEntityIfNeeded, userSubscription, [client, profile.id]);

        case 9:
          subscription = _context3.sent;
          plan = deepExtract('current_subscription.plan', subscription);

          if (!PlanDeriver.isCostcoPlan(plan)) {
            _context3.next = 16;
            break;
          }

          searchString = deepExtract('location.search', nextState, '');
          _context3.next = 15;
          return call(replaceState, "/settings/membership".concat(searchString));

        case 15:
          return _context3.abrupt("return", _context3.sent);

        case 16:
          if (!(!subscription || !subscription.allow_plan_selection)) {
            _context3.next = 19;
            break;
          }

          _context3.next = 19;
          return call(replaceState, '/settings');

        case 19:
          if (!(subscription && subscription.current_subscription && subscription.current_subscription.plan)) {
            _context3.next = 23;
            break;
          }

          if (!subscription.current_subscription.plan.commitment) {
            _context3.next = 23;
            break;
          }

          _context3.next = 23;
          return call(replaceState, '/settings/membership');

        case 23:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}
export function addOnsOnEnterSaga(client, replaceState, nextState) {
  var profile, permissions, searchString;
  return regeneratorRuntime.wrap(function addOnsOnEnterSaga$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return call(fetchEntityIfNeeded, userProfile, [client]);

        case 2:
          profile = _context4.sent;
          _context4.next = 5;
          return call(fetchEntityIfNeeded, userPermissions, [client, profile.id]);

        case 5:
          permissions = _context4.sent;

          if (memberStatus('ACTIVE', profile && profile.membership && profile.membership.status)) {
            _context4.next = 11;
            break;
          }

          _context4.next = 9;
          return call(replaceState, '/settings');

        case 9:
          _context4.next = 15;
          break;

        case 11:
          if (permissions.class_bundles) {
            _context4.next = 15;
            break;
          }

          searchString = deepExtract('location.search', nextState, '');
          _context4.next = 15;
          return call(replaceState, "/settings/membership".concat(searchString));

        case 15:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}